import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const PARTIAL_PAYMENT_FETCHER = Symbol('PARTIAL_PAYMENT_FETCHER')


class PartialPaymentResponse {
}


export interface PartialPaymentFetcher {
  selectPartialPayment(formData: FormData, partialPaymentUrl: string): Promise<PartialPaymentResponse>
}

@registerDependency(FAKE, PARTIAL_PAYMENT_FETCHER)
export class FakePartialPaymentFetcher implements PartialPaymentFetcher {
  payment_amount: string | undefined

  async selectPartialPayment(formData: FormData): Promise<PartialPaymentResponse> {
    if (formData.get('payment_amount')) {
      this.payment_amount = formData.get('payment_amount') as string
    }

    return new PartialPaymentResponse()
  }
}

@registerDependency(REAL, PARTIAL_PAYMENT_FETCHER)
export class RealPartialPaymentFetcher implements PartialPaymentFetcher {
  async selectPartialPayment(formData: FormData, partialPaymentUrl: string): Promise<PartialPaymentResponse> {
    await fetch(partialPaymentUrl, {  // nosemgrep
      method: 'POST',
      body: formData,
    })
    return new PartialPaymentResponse()
  }
}
